import { Skeleton } from '@/common/components/ui/skeleton';

export const OrganizationsPageSkeleton = () => (
  <div className="space-y-6 pb-10">
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
      <div className="flex flex-col gap-1">
        <Skeleton className="h-8 max-w-[220px] w-full" />
        <Skeleton className="h-5 max-w-[380px] w-full" />
      </div>
      <Skeleton className="h-9 w-[160px] shrink-0 self-start sm:self-auto" />
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <Skeleton className="h-[180px] rounded-2xl" />
      <Skeleton className="h-[180px] rounded-2xl" />
      <Skeleton className="h-[180px] rounded-2xl" />
    </div>
  </div>
);
